// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__Z8glv","content":"style_content__ITY6B","icon":"style_icon__GPjGr","text":"style_text__ACSjB","link":"style_link__Q1-ws"};